<template>
    <div>
        <div class="page-header page-header-small clear-filter">
            <parallax class="page-header-image"
                      style="background-image:url('img/bg3.jpg')">
            </parallax>
            <div class="content-center brand">
                <h1 class="h1-seo">Complaints</h1>
            </div>
        </div>

        <section id="general" class="section">
            <div class="container">
                <div class="row justify-content-md-center">
                    <div class="col-md-12 col-lg-8">
                        <p>If you would like to report a complaint, we kindly request you to send an email to info@alphabasedcapital.com explaining your message. You will receive a confirmation and strive to respond within 2 weeks.</p>
                        <p>Alpha Based Capital Fund Management BV is affiliated with Kifid (Het Financiële Klachteninstituut).</p>
                        <img v-lazy="'img/logo-kifid-color.svg'" alt="" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import { Parallax } from '@/components';

    export default {
        name: 'index',
        bodyClass: 'index-page',
        data() {
            return {
            }
        },
        components: {
            Parallax
        }
    };
</script>
<style></style>
